import { createVisibilityObserver } from '@solid-primitives/intersection-observer';
import { Meta } from '@solidjs/meta';
import { AccessLogo, Container, Link, NavLink, Button } from '@troon/ui';
import { createSignal, Suspense } from 'solid-js';
import { ErrorBoundary } from '../components/error-boundary';
import { Footer } from '../components/footer';
import { SkipToMain } from '../components/skip-to-main';
import { getConfigValue } from '../modules/config';
import type { RouteSectionProps } from '@solidjs/router';

export default function ForCourses(props: RouteSectionProps) {
	const [topTarget, setTopTarget] = createSignal<Element>();

	// oxlint-disable-next-line solid/reactivity
	const atTop = createVisibilityObserver({ threshold: 0.1 })(topTarget);

	return (
		<Suspense>
			<Meta name="og:image" content={`${getConfigValue('IMAGE_HOST')}/for-courses/og.png`} />
			<SkipToMain id="content" />
			<ErrorBoundary>
				<div class="flex min-h-svh flex-col justify-stretch">
					<div ref={setTopTarget} class="pointer-events-none absolute inset-x-0 top-0 h-6" />
					<nav
						role="navigation"
						class="sticky inset-x-0 top-0 z-40 h-16 border-b transition-colors duration-200"
						classList={{
							'border-white bg-white': !topTarget() || atTop(),
							'border-deprecated-neutral bg-white/95': !atTop(),
						}}
					>
						<Container class="h-full flex-row items-center justify-between">
							<NavLink href="/" size="logo">
								<AccessLogo class="w-32 md:w-36" aria-label="Access Powered by Troon" />
								<span class="sr-only">Golf with Access</span>
							</NavLink>

							<Button as={Link} href="/for-courses#schedule" size="md">
								Schedule Demo
							</Button>
						</Container>
					</nav>
					<main id="content">{props.children}</main>
				</div>
				<Footer />
			</ErrorBoundary>
		</Suspense>
	);
}
